import { render, staticRenderFns } from "./MsCheckbox.vue?vue&type=template&id=92c640d8&scoped=true&lang=html"
import script from "./MsCheckbox.vue?vue&type=script&lang=js"
export * from "./MsCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MsCheckbox.vue?vue&type=style&index=0&id=92c640d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c640d8",
  null
  
)

export default component.exports